<template>
  <div class="home-page">
    <!-- <div class="container">
      <MiniSearch :range="15"></MiniSearch>
    </div> -->
    <!-- Mounted only once the browser goes idle. The popup renders a DevExtreme
         DxForm, so a static import put all of DevExtreme in the homepage's initial
         JS graph for a dialog that never shows before 3.5s (and never at all for
         returning or logged-in visitors). The component keeps its own
         seen/auth/delay gates — this only defers when it mounts. -->
    <LazyWidgetsNewsletterPopup v-if="isIdle" class="bg-white" />
    <!-- Single page-level h1 for SEO. The hero is a banner carousel, so the
         heading is visually hidden rather than duplicated on screen. -->
    <h1 class="sr-only">{{ $t('seo.title') }}</h1>
    <!-- LCP Hero Banner - Rendered on server for fast FCP/LCP -->
    <div class="w-full bg-white">
    <div class="bg-white rounded-lg shadow-md p-6">
      <div id="slider-img" class="slides top-cover-slide w-full relative" style="aspect-ratio: 1770/530;" v-if="coverSlider && coverSlider.length">
        <!-- SSR: Show first slide immediately (LCP element) -->
        <div class="flex slides top-cover-slide w-full relative items-center justify-center select-none" style="aspect-ratio: 1770/530;" v-if="coverSlider && coverSlider.length">
        <!-- Left Preview Image (desktop only) -->
        <div class="absolute left-0 z-10 hidden md:flex w-[800px] h-full items-center justify-center">
          <NuxtLinkLocale v-if="coverSlider.length" :to="coverSlider[prevIndex]?.url" aria-label="Previous banner">
            <img v-if="coverSlider[prevIndex]?.image?.url" :src="imgUrl(coverSlider[prevIndex].image.url, 768)" :alt="coverSlider[prevIndex]?.alt || 'Previous banner'" class="h-full w-full object-cover opacity-70 rounded-3xl transition-all duration-500 ease-out" />
          </NuxtLinkLocale>
        </div>
        <!-- Center Image -->
        <div class="relative z-20 w-full md:w-[calc(100%-420px)] h-full flex items-center justify-center px-2 md:px-0">
          <NuxtLinkLocale v-if="coverSlider.length" :to="coverSlider[currentIndex]?.url" aria-label="Banner Link">
            <img v-if="coverSlider[currentIndex]?.image?.url" :src="imgUrl(coverSlider[currentIndex].image.url, 1770)" :alt="coverSlider[currentIndex]?.alt || 'Banner'" class="h-full w-full object-cover rounded-3xl transition-all duration-500 ease-out cursor-pointer" />
          </NuxtLinkLocale>
        </div>
        <!-- Right Preview Image (desktop only) -->
        <div class="absolute right-0 z-10 hidden md:flex w-[800px] h-full items-center justify-center">
          <NuxtLinkLocale v-if="coverSlider.length" :to="coverSlider[nextIndex]?.url" aria-label="Next banner">
            <img v-if="coverSlider[nextIndex]?.image?.url" :src="imgUrl(coverSlider[nextIndex].image.url, 768)" :alt="coverSlider[nextIndex]?.alt || 'Next banner'" class="h-full w-full object-cover opacity-70 rounded-3xl transition-all duration-500 ease-out" />
          </NuxtLinkLocale>
        </div>
        <!-- Previous Button -->
        <button class="absolute left-3 top-1/2 -translate-y-1/2 bg-[#009d66]/90 hover:bg-[#008556] text-white rounded-full p-2 shadow transition z-30 border-0" @click="prev">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
          </svg>
        </button>
        <!-- Next Button -->
        <button class="absolute right-3 top-1/2 -translate-y-1/2 bg-[#009d66]/90 hover:bg-[#008556] text-white rounded-full p-2 shadow transition z-30 border-0" @click="next">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
          </svg>
        </button>
        <!-- Dots Indicator -->
        <div class="absolute -bottom-4 flex items-bottom justify-center gap-2 z-30 w-full">
          <button v-for="(item, i) in coverSlider" :key="i" class="h-2.5 rounded-full transition-all"
            :class="i === currentIndex ? 'w-8 bg-[#009d66]' : 'w-2.5 bg-[#009d66] hover:bg-[#008556]'" @click="goTo(i)" />
        </div>
      </div>
    </div>
    <!-- Skeleton placeholder when no data -->
    <div v-else id="blank-space" class="border homeShadeWrap w-full bg-white" style="aspect-ratio: 1770/530;"></div>
    </div>
    </div>

    <!-- Upcoming Key Moments (CMS-driven, hidden while Strapi has no data) -->
    <HomeKeyMoments />

    <!-- Publisher spotlight (CMS-driven, hidden while Strapi has no data) -->
    <HomePublisherSpotlight />

    <!-- License spotlight (CMS-driven, hidden while Strapi has no data) -->
    <HomeLicenseSpotlight />

    <!-- <div id="center-text" class="container">
      <h2 class="text-center mid-text mt-5">{{ $t('this_weeks_highlights') }}</h2>
    </div> -->


    <!-- Secondary slider - Below the fold, can stay in ClientOnly -->
    <!-- <ClientOnly fallbackTag="span">
      <div class="slides" style="min-height: 323px;" v-if="sliderImages.length">
        <template v-if="shouldRenderSwipers">
          <swiper-container :loop="true" :rewind="true" :watchSlidesProgress="true" :spaceBetween="0"
            :slidesPerView="slidesPerView" :navigation="true" :pagination="true" :grabCursor="true"
            :centeredSlides="false" :autoplay="{
              delay: 3000,
              disableOnInteraction: false,
            }" :modules="modules" class="mySwiper swiper">
            <swiper-slide v-for="slide in sliderImages" :key="slide.id + '_sws'" class="swiper-slide">
              <template v-if="slide?.url">
                <NuxtLinkLocale :to="slide.url" :key="slide.id + '_nl'" aria-label="Image-Link">
                   <img :key="slide.id + '_img'" 
                        class="cover-slider-bottom-img w-full h-auto object-cover" 
                        :src="imgUrl(slide.image.url, 450)" 
                        alt="Slider image" 
                        width="450" height="323"
                        loading="lazy"
                        decoding="async"
                        style="aspect-ratio: 450/323;" />
                </NuxtLinkLocale>
              </template>
            </swiper-slide>
          </swiper-container>
        </template>
        <template v-else>
         
          <div class="flex gap-1 overflow-hidden" style="min-height: 323px;">
            <template v-for="slide in sliderImages.slice(0, 3)" :key="slide.id + '_static'">
              <NuxtLinkLocale v-if="slide?.url" :to="slide.url" class="flex-1" aria-label="Image-Link">
                <img class="w-full h-auto object-cover" 
                     :src="imgUrl(slide.image.url, 450)" 
                     alt="Slider image" 
                     width="450" height="323"
                     loading="lazy"
                     decoding="async"
                     style="aspect-ratio: 450/323;" />
              </NuxtLinkLocale>
            </template>
          </div>
        </template>
      </div>
      <template #fallback>
        <div id="static-img" class="shadeWrap placeholder bg-light loading for_slider_multi mb-5" style="min-height: 323px;">
          <div class="itemshed pl-1"></div>
          <div class="itemshed pl-1"></div>
          <div class="itemshed"></div>
        </div>
      </template>

    </ClientOnly> -->

    <div class="welcome-products-container bg-white">
      <Suspense>
        <template #default>
          <LazyWelcomeProductsList></LazyWelcomeProductsList>
        </template>
        <template #fallback>
          <div class="welcome-products-skeleton" aria-hidden="true">
            <div class="welcome-products-skeleton__title"></div>
            <div class="welcome-products-skeleton__grid">
              <div v-for="n in 8" :key="n" class="welcome-products-skeleton__card"></div>
            </div>
          </div>
        </template>
      </Suspense>
    </div>

    <!-- "Why retailers choose CLD" trust grid (mockup v3) -->
    <HomeTrustGrid />

    <!-- "About CLD Distribution" story banner with "Our Story" CTA (mockup v3) -->
    <HomeCldPresentation />
  </div>
</template>

<script setup>

import { shallowRef } from 'vue';
import { useCmsStore } from "~/store/cms/cmsStore";
import { useProductStore } from "~/store/ProductStore";
import { useUserStore } from "~/store/UserStore";

definePageMeta({
  middleware: 'set-layout'
});
const productStore = useProductStore();
const userStore = useUserStore();
const isAuthenticated = computed(() => userStore.isAuthenticated);
const products = computed(() => productStore.welcomProducts);
const productExist = computed(() => !!Object.keys(products.value).length);
// custom slider state
const currentIndex = ref(0);
const prevIndex = computed(() => coverSlider.value && coverSlider.value.length ? (currentIndex.value - 1 + coverSlider.value.length) % coverSlider.value.length : 0);
const nextIndex = computed(() => coverSlider.value && coverSlider.value.length ? (currentIndex.value + 1) % coverSlider.value.length : 0);

function prev() {
  if (!coverSlider.value?.length) return;
  currentIndex.value = (currentIndex.value - 1 + coverSlider.value.length) % coverSlider.value.length;
  resetAutoSlide();
}
function next() {
  if (!coverSlider.value?.length) return;
  currentIndex.value = (currentIndex.value + 1) % coverSlider.value.length;
  resetAutoSlide();
}
function goTo(i) {
  if (!coverSlider.value?.length) return;
  currentIndex.value = i;
  resetAutoSlide();
}

// Auto sliding for main slider
let autoSlideTimer = null;
function startAutoSlide() {
  stopAutoSlide();
  autoSlideTimer = setInterval(() => {
    if (coverSlider.value && coverSlider.value.length) {
      currentIndex.value = (currentIndex.value + 1) % coverSlider.value.length;
    }
  }, 4000); // 4 seconds
}
function stopAutoSlide() {
  if (autoSlideTimer) {
    clearInterval(autoSlideTimer);
    autoSlideTimer = null;
  }
}
function resetAutoSlide() {
  startAutoSlide();
}

// Gates the newsletter popup's mount (see the template) so its DevExtreme chunk is
// never part of the initial homepage load.
const isIdle = ref(false);

onMounted(() => {
  startAutoSlide();

  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(() => (isIdle.value = true), { timeout: 3000 });
  } else {
    setTimeout(() => (isIdle.value = true), 1500);
  }
});
onUnmounted(() => {
  stopAutoSlide();
});
const cmsStore = useCmsStore();

// Pre-fetch critical data on server
await useAsyncData('home_cms_data', async () => {
  await Promise.all([
    cmsStore.getCoverSliders(),
    cmsStore.getCmsSlider(),
    cmsStore.getKeyMoments()
  ]);
  return true;
});

const sliderImages = computed(() => cmsStore.sliderImages);
const coverSlider = computed(() => cmsStore.coverSlider);
const slidesPerView = ref(3);
// Responsive image URL helper - serves appropriately sized images
const imgUrl = (url, w, q = 80) => cmsStore.getImageUrl(`/cdn-cgi/image/width=${w},quality=${q}${url}`);

// Generate srcset for responsive images
const getSrcSet = (url) => {
  const sizes = [480, 768, 1024, 1440, 1770];
  return sizes.map(w => `${imgUrl(url, w)} ${w}w`).join(', ');
};

const firstCoverHref = computed(() => {
  const first = coverSlider.value?.[0]?.image?.url;
  return first ? imgUrl(first, 768) : null; // Mobile-first preload
});

const firstCoverHrefDesktop = computed(() => {
  const first = coverSlider.value?.[0]?.image?.url;
  return first ? imgUrl(first, 1770) : null;
});

const { t } = useI18n();
const route = useRoute();

// Organization + WebSite structured data: helps Google build the brand panel
// and can enable the sitelinks search box for cld.eu.
const homeJsonLd = JSON.stringify({
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://cld.eu/#organization",
      name: "CLD Distribution",
      url: "https://cld.eu",
      description: t('cld_desc1').replace('{newline}', ' '),
      foundingDate: "1998",
      address: {
        "@type": "PostalAddress",
        streetAddress: "Rue du Grand Champs 14",
        postalCode: "5380",
        addressLocality: "Fernelmont",
        addressCountry: "BE",
      },
      contactPoint: {
        "@type": "ContactPoint",
        telephone: "+32-81-83-02-02",
        email: "infos@cld.be",
        contactType: "customer service",
        areaServed: "EU",
      },
    },
    {
      "@type": "WebSite",
      "@id": "https://cld.eu/#website",
      url: "https://cld.eu",
      name: "CLD Distribution",
      publisher: { "@id": "https://cld.eu/#organization" },
      potentialAction: {
        "@type": "SearchAction",
        target: {
          "@type": "EntryPoint",
          urlTemplate: "https://cld.eu/en/products/search?q={search_term_string}",
        },
        "query-input": "required name=search_term_string",
      },
    },
  ],
});

useHead(() => {
  const links = [];
  // Desktop preload only (since slider is hidden on mobile)
  if (firstCoverHrefDesktop.value) {
    links.push({
      rel: 'preload',
      as: 'image',
      href: firstCoverHrefDesktop.value,
      media: '(min-width: 769px)',
      fetchpriority: 'high'
    });
  }
  return {
    link: links,
    script: [{ type: 'application/ld+json', innerHTML: homeJsonLd }],
    // og tags: the homepage had none, so shares on LinkedIn/WhatsApp/Slack fell
    // back to whatever the scraper guessed. Image = first cover slide when the
    // CMS has one (1770px is fine; scrapers downscale), else the logo.
    meta: [
      { property: 'og:title', content: t('seo.title') },
      { property: 'og:description', content: t('cld_desc1').replace('{newline}', ' ') },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: `https://cld.eu${route.path}` },
      { property: 'og:site_name', content: 'CLD Distribution' },
      ...(firstCoverHrefDesktop.value
        ? [{ property: 'og:image', content: firstCoverHrefDesktop.value }]
        : []),
    ],
  };
});


</script>

<style scoped>
/* Swiper navigation arrows */
.swiper-button-next,
.swiper-button-prev {
  color: #22c55e !important; /* Tailwind green-500 */
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

/* Swiper pagination dots */
.swiper-pagination-bullet {
  background: #22c55e !important;
  opacity: 0.5;
}
.swiper-pagination-bullet-active {
  background: #22c55e !important;
  opacity: 1;
}
/* TODO CONFIRM THIS */
/* Blanket page-surface for homepage divs. Excluded: the page root (so the layout's white shows around
   sections) and this page's own `.bg-white` wrappers/cards (hero banner) plus their contents. */
div:not(.home-page[data-v-02281a80], .bg-white[data-v-02281a80], .bg-white[data-v-02281a80] *)[data-v-02281a80] { background: var(--cld-page-surface); background-color: var(--cld-page-surface); padding: 3px 0px;}

#slide-img {  width: -webkit-fill-available;}

.slides { padding-bottom: 10px; }

.swiper-slide {
  text-align: center;
  font-size: 18px;
  /* background: #fff; */

  /* Center slide text vertically */
  display: block;
  margin: 0 2px;
}

.swiper {
  width: 100%;
  height: fit-content;
  box-sizing: content-box;
}

.category-text {
  margin: 0 0 0 0 !important;
}

.slider-placeholder {
  max-height: 530px;
  width: 100%;
}

.slide {
  /* flex: 1; */
  /* Makes each item take up equal space */
  min-height: 530px;
  /* Sets a minimum height */
  background-color: #a3a3a3
    /* Optional: for visibility */
}

.homeShadeWrap {
  /* background-color: #dad7d7; */
  height: auto;
  aspect-ratio: 1770 / 530; 
}

.shadeWrap {
  display: flex;
  gap: 3px;
  /* height: 810px; */
  height: auto;
  aspect-ratio: 1770 / 810;
}

#static-img {
  /* min-height: 323px;
  max-height: 1185px; */
  aspect-ratio: 1350/323; /* 450*3 / 323 */
}
#center-text{
  min-height: 64px;
  max-height: 76px;
}

/* h2{
  min-height: 64px;
  max-height: 75px;
} */
#product-container.row {
  max-height: 480px;
  min-height: 480px;
}

#slider-img {
  /* background-color: red; */
  min-height: 0;
  max-height: 1770px;
}

@media (min-width: 768px) {
  #slider-img {
    min-height: 445px;
  }
}
/* #blank-space{
  background-color: red;
} */
.itemshed {
  flex: 1;
  background-color: #a3a3a3
}

.customCls {
  min-height: 380px;
}

/* Removed min-height from welcome-products-container as it was causing major CLS
   (0.3652 + 0.1747 = 0.5399 total) when actual content height differed from reserved space.
   Lazy-loaded content will render naturally without forced height constraints. */

.mediaQuery {
  display: grid;
  grid-gap: 0;
  /* Default gap */
}

.colmns {
  padding: 10px;
  text-align: center;
}




@media (max-width: 480px) {
  /* .homeShadeWrap {
    height: 110px;
  } */

  .mediaQuery {
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 20px;
  }

  .thirdDiv,
  .fourthDiv,
  .lastDiv,
  .secondLine {
    display: none;
  }


}

@media (min-width: 481px) and (max-width: 575.98px) {
  .homeShadeWrap {
    height: 150px;
  }

  .shadeWrap {
    height: 130px;
  }
}

@media (min-width: 576px) and (max-width: 680px) {
  .homeShadeWrap {
    height: 190px;
  }

  .shadeWrap {
    height: 160px;
  }
}

@media (min-width: 681px) and (max-width: 767.99px) {
  .homeShadeWrap {
    height: 270px;
  }

  .shadeWrap {
    height: 180px;
  }
}

@media (min-width: 768px) and (max-width: 991.98px) {
  .homeShadeWrap {
    height: 270px;
  }

  .shadeWrap {
    height: 230px;
  }
}

@media (min-width: 992px) and (max-width: 1199.99px) {
  .homeShadeWrap {
    height: 370px;
  }

  .shadeWrap {
    height: 280px;
  }
}

@media (min-width: 1200px) and (max-width: 1600px) {
  .homeShadeWrap {
    height: 480px;
  }

  .shadeWrap {
    height: 370px;
  }
}

@media (min-width: 1601px) and (max-width: 1920px) {
  .homeShadeWrap {
    height: 530px;
  }

  .shadeWrap {
    height: 445px;
  }
}

@media (min-width: 1921px) and (max-width: 2000px) {
  .homeShadeWrap {
    height: 620px;
  }

  .shadeWrap {
    height: 460px;
  }
}

@media (min-width: 2001px) and (max-width: 2500.99px) {
  .homeShadeWrap {
    height: 870px;
  }

  .shadeWrap {
    height: 580px;
  }
}


@media (min-width: 481px) and (max-width: 992px) {
  .mediaQuery {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 12px;
  }

  .lastDiv,
  .secondLine {
    display: none;
  }
}

@media (min-width: 993px) {
  .mediaQuery {
    grid-template-columns: repeat(5, 1fr);
    grid-gap: 18px;
  }
}
.welcome-products-container{
  content-visibility: auto;
  contain-intrinsic-size: 1px 900px;
}

.welcome-products-skeleton{
  padding: 16px 0;
  min-height: 900px;
}

.welcome-products-skeleton__title{
  height: 28px;
  width: 320px;
  margin: 0 auto 18px auto;
  border-radius: 8px;
  background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 37%, #e5e7eb 63%);
  background-size: 400% 100%;
  animation: shimmer 1.4s ease infinite;
}

.welcome-products-skeleton__grid{
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  padding: 0 12px;
}

.welcome-products-skeleton__card{
  height: 240px;
  border-radius: 12px;
  background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 37%, #e5e7eb 63%);
  background-size: 400% 100%;
  animation: shimmer 1.4s ease infinite;
}

@keyframes shimmer{
  0%{ background-position: 100% 0; }
  100%{ background-position: 0 0; }
}

@media (max-width: 991.98px){
  .welcome-products-skeleton__grid{ grid-template-columns: repeat(2, minmax(0, 1fr)); }
}

@media (max-width: 480px){
  .welcome-products-skeleton__grid{ grid-template-columns: repeat(1, minmax(0, 1fr)); }
}
</style>
